import comp from "./BulkDownload";
export default comp;
